{
  "version": 1,
  "asset_id": "34b3f450-eb91-40cc-9eff-ecf49cacbfef",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/34b3f450-eb91-40cc-9eff-ecf49cacbfef/sleeve-normal-revision-800.jpg",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/34b3f450-eb91-40cc-9eff-ecf49cacbfef/sleeve-normal-revision-800.jpg",
  "original_filename": "sleeve-normal-revision-800.jpg",
  "size": 77518,
  "content_type": "image/jpeg",
  "created_at": "2026-10-05T01:21:38Z"
}
